const sessionCount = (item) => {
  const value = Number(item?.value ?? item?.count ?? 0);
  return Number.isFinite(value) && value > 0 ? value : 0;
};

export const buildSessionTrend = (completedHistory = [], upcomingHistory = []) => {
  const completed = Array.isArray(completedHistory) ? completedHistory : [];
  const upcoming = Array.isArray(upcomingHistory) ? upcomingHistory : [];
  const labels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const points = labels.map((label, index) => {
    const completedValue = sessionCount(completed[index % Math.max(completed.length, 1)]);
    const upcomingValue = sessionCount(upcoming[index % Math.max(upcoming.length, 1)]);
    return {
      label,
      completed: completedValue,
      scheduled: completedValue + upcomingValue,
    };
  });
  const max = Math.max(1, ...points.map((point) => Math.max(point.scheduled, point.completed)));
  return points.map((point) => ({ ...point, max }));
};
